import React, { useRef } from "react";
import styled from "styled-components";

import Modal from "../../../components/Modal";
import AdminButton from "../action_engine/AdminButton";

const INTENT_LABELS = {
  danger: "Action sensible",
  warning: "Confirmation requise",
  default: "Confirmation",
};

export default function AdminConfirmationDialog({
  request,
  onConfirm,
  onCancel,
}) {
  const confirmButtonRef = useRef(null);

  if (!request) {
    return null;
  }

  const {
    title = INTENT_LABELS.default,
    message = "",
    confirmLabel = "Confirmer",
    cancelLabel = "Annuler",
    intent = "default",
  } = request.options || {};

  return (
    <Modal
      onClose={onCancel}
      role="alertdialog"
      ariaLabelledBy={`admin-confirmation-title-${request.id}`}
      ariaDescribedBy={`admin-confirmation-message-${request.id}`}
      initialFocusRef={confirmButtonRef}
    >
      <ConfirmationRoot>
        <ConfirmationTitle id={`admin-confirmation-title-${request.id}`}>
          {title}
        </ConfirmationTitle>

        {intent !== "default" && (
          <IntentLabel data-intent={intent}>
            {INTENT_LABELS[intent] || INTENT_LABELS.default}
          </IntentLabel>
        )}

        <Message id={`admin-confirmation-message-${request.id}`}>
          {message}
        </Message>

        <Actions>
          <CancelButton
            type="button"
            variant="ghost"
            onClick={onCancel}
          >
            {cancelLabel}
          </CancelButton>

          <ConfirmButton
            ref={confirmButtonRef}
            type="button"
            variant={intent === "danger" ? "danger" : "primary"}
            data-intent={intent}
            onClick={onConfirm}
          >
            {confirmLabel}
          </ConfirmButton>
        </Actions>
      </ConfirmationRoot>
    </Modal>
  );
}

const ConfirmationRoot = styled.div`
  width: min(480px, 100%);
`;

const ConfirmationTitle = styled.h2`
  margin: 0 2.5rem 1rem 0;
  color: ${({ theme }) => theme?.colors?.text || "#f7f7f7"};
  font-size: 1.25rem;
  line-height: 1.3;
`;

const IntentLabel = styled.div`
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  margin-bottom: 0.85rem;
  padding: 0.2rem 0.7rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: ${({ theme }) => theme?.colors?.text || "#f7f7f7"};
  font-size: 0.78rem;
  font-weight: 700;

  &[data-intent="danger"] {
    background: rgba(214, 66, 66, 0.18);
    color: #ffd7d7;
  }

  &[data-intent="warning"] {
    background: rgba(232, 174, 58, 0.18);
    color: #ffe5aa;
  }
`;

const Message = styled.p`
  margin: 0;
  color: ${({ theme }) => theme?.colors?.text || "#f7f7f7"};
  font-size: 0.98rem;
  line-height: 1.55;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;

  @media (max-width: 520px) {
    flex-direction: column-reverse;
  }
`;

const CancelButton = styled(AdminButton)``;

const ConfirmButton = styled(AdminButton)`
  &[data-intent="warning"] {
    background: #b56b00;
    color: #ffffff;
    border-color: transparent;

    &:not(:disabled):hover {
      background: #c57800;
    }

    &:not(:disabled):active {
      background: #985a00;
    }
  }
`;
